/* eslint-disable react/prop-types */
import React from 'react';
import '../App.scss';

//import Load from 'src/assets/base/Load.gif';

import { LoadGif3 } from './LoadGif3';

export function LoadGif() {
  return (
    <div className="baseLoad absoluteCenter">
      <div>
        {/*<img src={Load} />*/}
        <LoadGif3 />
      </div>
    </div>
  );
}
